module.exports = __webpack_public_path__ + "static/media/1.d3abcbfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/17013/1.jpg
// module id = 582
// module chunks = 0